export const dashboard_config = {
    mode:'DEV',
    api_url: "http://192.168.1.111:8000",
    api_auth_url: "http://192.168.1.111:8000/o/token/",
    search_resources_path: 'search/resources',
    search_concepts_path: 'concepts/search',
    search_related_resources_path: 'resource/related',
    search_reports_path: 'search/resources',
    search_graph_path: 'dashboard',
    auth: {
        username: 'admin',
        password: 'admin',
        client_id: 'MOt8hhvaEjM3S1Kj8fdeOOsGy6wEu1z4KsRWWY61',
        grant_type: 'password'
    },
    'archaeological_heritage_graph_id': '99417385-b8fa-11e6-84a5-026d961c88e6',
    'archaeological_heritage_name': 'Bene Archeologico',
    'archaeological_heritage_area_tile_id': '2dda3826-4345-11ea-a470-08002713135a',
    'archaeological_general_data_tile_id': '1667fc86-4343-11ea-a470-08002713135a',
    'archaeological_related_3dhops_graph_id': '9b591814-c0f2-11e8-9c8c-0242ac120004',
    'report_graph_id': '0eb358a6-3172-11ea-8080-080027c5bc64',
    'hop3d_heritage_tile_id': '78df9e1a-8ded-11ea-8278-08002776b909',
    'hop3d_graph_id':'9b591814-c0f2-11e8-9c8c-0242ac120004',
    'hope3d_title_label':'Titolo',
    'hope3d_description_label':'Descrizione',
    'hope3d_image_preview_label':'Immagine di anteprima',
    heritage_area_concept_name: 'Area/settore archeologico',
    heritage_graph_name: 'Bene Archeologico',
    'area_concept_id': '2e47db53-4fd4-4c4e-beaa-df1686989932'
}

export const status_values= {
    NO_TASK: 'no_task',
    TASK_REPORT: 'task_report',
    ARCHEO_HERITAGE_SELECT: 'task_report_archeo_heritage_select',
    REPORT_TYPE_SELECT: 'task_report_type_selection',
    HOP3D_SELECT: 'task_report_hop3d_selection',
    TASK_SELECT: 'task_select',
    CARD_CREATE: 'card_create',
    CARD_CREATE_RESOURCE_SELECT: 'card_create_resource_select',
    CARD_SEARCH: 'card_search',
    CARD_SEARCH_SELECT: 'card_search_select'
};

export const dash_tasks = {
    [status_values.NO_TASK]: {
        status: status_values.NO_TASK,
        help_message: 'Apri pannello per iniziare',
    },
    [status_values.TASK_REPORT]: {
        status: status_values.TASK_REPORT,
        help_message: 'Stai compilando una segnalazione',
        ref: "report",
        displayName: "COMPILA SEGNALAZIONE",
        description: 'Compila una segnalazione relativa ad un problema riscontrato.',
        iconClass: "fa-file",
        buttonClass: "btn btn-success",
        header_filters_active: {'text': false, 'combo': false, 'multiple_combo': false},
        footer_items_active: {'paginator': false},
        workflow_steps: 2,
        workflow_current_index: 0,
        workflow:[
                {   help_message: 'Seleziona Bene Archeologico',
                    status: status_values.TASK_REPORT,
                    step: status_values.ARCHEO_HERITAGE_SELECT,
                    ref: "reportHeritageSelect",
                    displayName: "SEGNALAZIONE",
                    iconClass: "fa fa-user",
                    header_filters_active: {'text': true, 'combo': false, 'multiple_combo': true, 'combo_name': 'Area', 'multiple_combo_name': 'Settore'},
                    footer_items_active: {'paginator': true},
                    workflow_index: 0
                },{
                    help_message: 'Seleziona Tipo Registrazione',
                    status: status_values.TASK_REPORT,
                    step: status_values.REPORT_TYPE_SELECT,
                    ref: "reportTypeSelect",
                    displayName: "SEGNALAZIONE",
                    iconClass: "fa fa-user",
                    header_filters_active: {'text': false, 'combo': false, 'multiple_combo': false, 'combo_name': '', 'multiple_combo_name': ''},
                    footer_items_active: {'paginator': false},
                    workflow_index: 1
                },
                {    
                    help_message: 'Seleziona Nuvola di Punti',
                    status: status_values.TASK_REPORT,
                    step: status_values.HOP3D_SELECT,
                    ref: "reportHop3DSelect",
                    displayName: "SEGNALAZIONE",
                    iconClass: "fa fa-user",
                    header_filters_active: {'text': true, 'combo': false, 'multiple_combo': false, 'combo_name': '', 'multiple_combo_name': ''},
                    footer_items_active: {'paginator': true},
                    workflow_index:2
                }
            ]
    },
    [status_values.TASK_SELECT]: {
        status: status_values.TASK_SELECT,
        help_message: "Seleziona un'attività",
        ref: "taskSelect",
        displayName: "SEGNALAZIONE",
        iconClass: "fa-search",
        header_filters_active: {'text': false, 'combo': false, 'multiple_combo': false},
        footer_items_active: {'paginator': false},
        buttonClass: "btn btn-default",
    },
    [status_values.CARD_CREATE]: {
        status: status_values.CARD_CREATE,
        help_message: "Scegli scheda da compilare",
        ref: "cardCreate",
        displayName: "CREA SCHEDA",
        description: 'Compila una nuova scheda da inserire nel sistema.',
        iconClass: "fa-plus",
        buttonClass: "btn btn-primary",
        header_filters_active: {'text': false, 'combo': false, 'multiple_combo': false},
        footer_items_active: {'paginator': false},
        workflow_steps: 0,
        workflow_current_index: 0,
        workflow:[
                {   help_message: 'Seleziona Risorsa',
                    status: status_values.CARD_CREATE,
                    step: status_values.CARD_CREATE_RESOURCE_SELECT,
                    ref: "cardCreateResourceSelect",
                    displayName: "Selezione risorsa",
                    iconClass: "fa fa-user",
                    header_filters_active: {'text': true, 'combo': false, 'multiple_combo': false, 'combo_name': '', 'multiple_combo_name': ''},
                    footer_items_active: {'paginator': false},
                    workflow_index: 0
                }
            ]
    },
    [status_values.CARD_SEARCH]: {
        status: status_values.CARD_SEARCH,
        help_message: "Modifica o visualizza risorsa",
        ref: "cardSearch",
        displayName: "CERCA SCHEDA",
        description: "Ricerca schede presenti all'interno del sistema per la visualizzazione del report relativo o per la modifica.",
        iconClass: "fa-search",
        buttonClass: "btn btn-primary",
        header_filters_active: {'text': true, 'combo': true, 'multiple_combo': false, 'combo_name': 'Tipo Scheda', 'multiple_combo_name': ''},
        footer_items_active: {'paginator': true},
        workflow_steps: 0,
        workflow_current_index: 0,
        workflow:[
                {   help_message: 'Modifica o visualizza risorsa',
                    status: status_values.CARD_SEARCH,
                    step: status_values.CARD_SEARCH_SELECT,
                    ref: "cardSearchSelect",
                    displayName: "Selezione risorsa da modificare o visualizzare",
                    iconClass: "fa fa-user",
                    header_filters_active: {'text': true, 'combo': true, 'multiple_combo': false, 'combo_name': 'Tipo scheda', 'multiple_combo_name': ''},
                    footer_items_active: {'paginator': true},
                    workflow_index: 0
                }
            ]
    }
}


